import { NewClient } from "./client";
import store from "@/_store";
import appConfig from "@/app.config";

const apiClient = new NewClient(appConfig.apiURL);

// Add a response interceptor
apiClient.client.interceptors.response.use(
  response => {
    if ({}.hasOwnProperty.call(response.data, "config_updates")) {
      // console.log("config_updates", response.data.config_updates);
      store.dispatch("config/mutateData", response.data.config_updates);
    }
    return response;
  },
  error => {
    if (error.response.status === 401) {
      store.dispatch("authentication/logout");
    }
    if (error.response.status === 403) {
      // console.log("update and retry");
      // location.reload();
      // console.log(error.response.data);
      if (error.response.data.code) {
        // if (error.response.data.code == )
        switch (error.response.data.code) {
          case "jwt_auth_invalid_token":
            store.dispatch("authentication/logout");
            break;
          case "jwt_auth_bad_iss":
            store.dispatch("authentication/logout");
            break;
          default:
            break;
        }
      }
    }
    if (error.response.status >= 500) {
      // Raven.captureException(error);
    }

    return Promise.reject(error);
  }
);

export { apiClient };
